import { axios } from '@Api/axiosClient';

export interface FraudEducationTask {
    taskId: string;
    status: string | null;
    text: string | null;
    youtubeUrl: string | null;
}

export const getFraudEducationTaskApi = async (taskId: string): Promise<FraudEducationTask> => {
    const response = await axios.get('api/FraudEducation/GetTask', { params: { taskId } });
    return response.data;
};

export const completeFraudEducationTaskApi = async (taskId: string): Promise<void> => {
    await axios.post('api/FraudEducation/CompleteTask', { taskId });
};
